<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter1" id="pgepubid00007">
<h2 class="c4">NATURAL ASTROLOGY</h2>
</div>
<p class="c10">Is confined to the study of exploring natural effects,
as <span class="fss">CHANGE OF WEATHER</span>, <span class="fss">WINDS</span>, <span class="fss">STORMS</span>,
<span class="fss">HURRICANES</span>, <span class="fss">THUNDER</span>, <span class="fss">FLOODS</span>, <span class="fss">EARTHQUAKES</span>,
and the like. In this sense it is admitted
to be a part of natural philosophy. It was
under this view that Mr. Goad, Mr. Boyle, and
Dr. Mead, pleaded for its use. The first endeavours
to account for the diversity of seasons from
the situations, habitudes, and motions of the planets;
and to explain an infinity of phenomena by
the contemplation of the stars. The Honourable
Mr. Boyle admitted, that all physical bodies are
influenced by the heavenly bodies; and the
<span id="Page_27" title="27"></span>Doctor’s opinion, in his treatise concerning the
<span class="sc">Power of the Sun and Moon</span>, &amp;c. is in favour
of the doctrine. But these predictions and
influences are ridiculed and entirely exploded by
the most esteemed modern philosophers, of which
the reader may have a learned specimen in <span class="sc">Rohault’s</span>
<em class="calibre12">Tract. Physic.</em> pt. ii. c. 27.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?663b5d04